import { queryOptions, useQuery } from '@tanstack/react-query';
import { useApi } from '../../api/api-context';
/**
 * Fetches SimpleFin accounts.
 *
 * @param {ReturnType<typeof useApi>} api - API instance for making requests.
 * @returns {Promise<SimpleFinAccount[]>} - A promise resolving to the list of accounts.
 */
const fetchSimpleFinAccounts = async (api) => {
    const response = await api.get('/simple-fin/accounts');
    return response.data;
};
/**
 * Exposed query options for fetching SimpleFin accounts.
 *
 * @param {ReturnType<typeof useApi>} api - API instance.
 * @returns Query options for React Query.
 */
export const getSimpleFinAccountsQueryOptions = (api) => queryOptions({
    queryKey: ['simple-fin-accounts'],
    queryFn: () => fetchSimpleFinAccounts(api),
});
/**
 * React Query hook for fetching SimpleFin accounts.
 *
 * @param {UseSimpleFinAccountsOptions} options - Optional configuration for the query.
 * @returns React Query response object.
 */
export const useGetSimpleFinAccountsApi = ({ queryConfig } = {}) => {
    const api = useApi();
    return useQuery({
        ...getSimpleFinAccountsQueryOptions(api),
        ...queryConfig,
    });
};
/**
 * Hook to get SimpleFin accounts.
 *
 * @returns {SimpleFinAccount[]} - The list of SimpleFin accounts.
 */
export const useSimpleFinAccounts = () => {
    const { data: accounts = [] } = useGetSimpleFinAccountsApi();
    return accounts;
};
